import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { MaintenanceService } from '@core/bootstrap';
import { map } from 'rxjs';

export const maintenanceGuard: CanActivateFn = (_, _state) => {
  const maintenance = inject(MaintenanceService);
  const router = inject(Router);

  return maintenance.isMaintenanceMode$.pipe(
    map(active => (active ? router.parseUrl('/maintenance') : true))
  );
};
